export default __webpack_public_path__ + "files/webinar3.pdf";